import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "lab" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Home Dev View", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "content" }, null, -1)
const _hoisted_4 = { class: "dev" }
const _hoisted_5 = { class: "dev" }
const _hoisted_6 = { class: "dev" }
const _hoisted_7 = { class: "dev" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "tech-flex",
  style: {"width":"500px","margin":"auto","margin-top":"200px"}
}

import { onMounted, ref, reactive } from 'vue'
import { useRouter } from 'vue-router';
import { useAppContext } from '@/app/_tech'
import { Guid } from '@/lib';
import AppContext from '@/context';
import { Sunrise, TimeSegment } from '@/logic/_infra/time';
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { WorkspaceRmodel } from '@/app.context/workspace.rmodel';

import { useNotification } from "@kyvg/vue3-notification";
import sys from '@/sys';






export default /*#__PURE__*/_defineComponent({
  __name: 'HomeDevView',
  setup(__props) {




const router = useRouter();
const context = useAppContext();
const { notify }  = useNotification()

const { authenticated } = context;

const model: { user: string, password: string } = reactive({ user: '', password: '' })

const error = ref('');

function authenticate_submit(e: Event) {


}

async function name() {

  //window.gapi.auth.getTok.auth2.getAuthInstance().isSignedIn.get()
  //window.gapi.auth.
}

function notification() {

  notify({
  title: "Error",
  text: "Problem connectig to server",
  type: "success",
  
});
}

async function listUpcomingEvents() {
  let response;

  try {
    const request: globalThis.gapi.client.calendar.EventsListParameters =
    {
      'calendarId': 'primary',
      'timeMin': (new Date()).toISOString(),
      //'timeMax'
      'showDeleted': false,
      'singleEvents': true,
      'maxResults': 10,
      'orderBy': "startTime",
    };
    //response = await gapi.client.request({path:'calendar/events/list', params:request}) 

    //const token = await window.gapi.client.getToken()

    //console.log(token)

    //window.gapi.client.load(DISCOVERY_DOC, initializeGapiClient)

    response = await window.gapi.client.calendar.events.list(request)

    console.log('response')
    console.log(response)

    //.calendar.events.list(request);
  } catch (err: any) {

    console.log(err)
    //document.getElementById('content').innerText = err.message;
    return;
  }




  const events = response.result.items;
  if (!events || events.length == 0) {
    console.log('no events found')
    document.getElementById('content')!.innerText = 'No events found.';
    return;
  }
  // Flatten to string to display
  const output = events.reduce(
    (str, event) => `${str}${event.summary} (${event.start.dateTime || event.start.date})\n`,
    'Events:\n');

  document.getElementById('content')!.innerText = output;

  console.log(output)
}

//const context = useAppContext()

const login = () => {

  const f = context.integrations.Google.requestAccessToken

  if (f != null) f(); else console.log('GAPI is not initialized yet')

}


function authenticate() {

  //empty login-pass make system grab the latest account when server setup in 'dev' mode
  context.authenticate(model.user, model.password).then((result: boolean) => {

    if (result) {

      console.log(`/home.vue - Authenticatd successfully`);

      error.value = '';

      // eslint-disable-next-line
      if (false) {


        //display /home screen with listed workspaces;
        //if workspace is sinle - redirect to iod or last worked on

        const wid = Guid.newGuid() as Guid;

        navigateProject(wid, wid);
      }
    }
    else {
      //display error warning
      error.value = "[Authentication:Failure]" //#literal
    }

  }).catch(sys.exception)
}

function navigateProject(wid: Guid, pid: Guid) {

  pid.toString();

  context.storages.workspace = context.service.workspaceStorage(wid);

  router.push('/workspace') //? match to wid?
}



function test_2(context: AppContext) {

  //const context = useAppContext()

  const wid = context.cursor.workspace!.wid;
  const n = 1;

  const s = context.storages.files

  const filename = 'Crown of Poland vs Kingdom of Poland.jpg'

  if (s != null) {

    s.pull(wid, n, filename).then(content => console.log(`Content l: ${content.byteLength}`)) //#DEV/TRACING

    s.url(wid, n, filename).then(url => console.log(url)) //#DEV/TRACING

    //console.log(url)
  }
  else console.log('problem')
}




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", { onClick: login }, "Login"),
    _createElementVNode("button", { onClick: listUpcomingEvents }, "Get"),
    _createElementVNode("button", { onClick: notification }, " Notification"),
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, [
      _createVNode(_component_router_link, { to: { name: 'lab' } }, {
        default: _withCtx(() => [
          _createTextVNode(" Lab ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_5, [
      _createVNode(_component_router_link, { to: { name: 'lab-calendar' } }, {
        default: _withCtx(() => [
          _createTextVNode(" Lab/Calendar ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_6, [
      _createVNode(_component_router_link, { to: { name: 'lab-history' } }, {
        default: _withCtx(() => [
          _createTextVNode(" Lab/History ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_7, [
      _createVNode(_component_router_link, { to: { name: 'lab-timeplaner' } }, {
        default: _withCtx(() => [
          _createTextVNode(" Lab/Timeplaner control ")
        ]),
        _: 1
      })
    ]),
    (_unref(authenticated))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", null, "Workspaces: " + _toDisplayString(_unref(context).model.workspaces.length), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(context).model.workspaces, (w) => {
            return (_openBlock(), _createElementBlock("div", {
              key: w.wid.toString()
            }, [
              _createElementVNode("p", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'project', params: { workspace: w.name, project: '' }, }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Name:" + _toDisplayString(w.name) + " Wid: " + _toDisplayString(w.wid), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("p", null, [
                _createTextVNode("Projects: "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.projects, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "mn-link",
                    onClick: ($event: any) => (navigateProject(w.wid, p.pid)),
                    key: p.pid.toString()
                  }, _toDisplayString(p.name), 9, _hoisted_9))
                }), 128))
              ]),
              _createTextVNode(" Projects: "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.projects, (p) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: p.pid.toString()
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'project', params: { workspace: w.name, project: p.name }, }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(p.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128)),
              _createTextVNode(" Persons: "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.persons, (p) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: p.nid.toString()
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'person', params: { workspace: w.name, person: p.name }, }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(p.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
          }), 128)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(context).logoff()))
          }, "OFF")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.password) = $event)),
            style: {"margin-right":"1em","width":"32em"},
            onKeyup: _withKeys(authenticate, ["enter"])
          }, null, 544), [
            [_vModelText, model.password]
          ]),
          _createElementVNode("button", { onClick: authenticate }, "Login")
        ]))
  ]))
}
}

})